module.exports = __webpack_public_path__ + "img/info-6.78004396.svg";